// import * as ReportService from '../../../http/PDFService'
const decodeHTML = function (html) {
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}
const actions = {
  sendPDF ({ state, commit, dispatch }, payload) {
    console.log(decodeHTML(payload.data))
    /*
    let url = `${ReportService.PDF_DATA_ENDPOINT}${token}`
    return new Promise((resolve, reject) => {
      ReportService.sendPDFtData(url).then(response => {
        if (response.status === 200) {
          commit('setReportPreferences', response.data.preferences)
          commit('createTimestamp', response.data.general.updated_at)
          commit('remapUnknowns')
          dispatch('checkImages', response.data.sections)
            .then(() => {
              commit('createReportSections', response.data.sections)
              resolve({ status: 'success', data: response.data })
            })
            .finally(() => {
              commit('mergePreferenceProperty')
            })
        }
      }, error => {
        reject(error)
      })
    })
    */
  },
}

export default actions
